import { graphql } from 'gql.tada';

// --- Backoffice namespace ---

export const GET_BUYERS = graphql(`
    query searchBuyers(
        $filter: BuyerSearchFilterInput,
        $orderBy: BuyerSearchOrderByInput,
        $pagination: BuyerSearchPaginationInput
    ) {
        buyers {
            backoffice(
                filter: $filter,
                orderBy: $orderBy,
                pagination: $pagination
            ) {
                count
                items {
                    billingEmail
                    broadcastLanguage
                    broadcastCountries {
                        countries
                        main
                    }
                    broadcastType
                    contactEmail
                    contactName
                    hourCost
                    identifier {
                        id
                        sku
                    }
                    legalName
                    licensesDuration
                    payoutTemplate
                    postalAddress
                    publicName
                    vatId
                    videoOutputBitrate
                    videoOutputFormat
                    businessProvider {
                        identifier {
                            id
                        }
                    }
                }
            }
        }
    }
`);

export const GET_BUYER_SUMMARY = graphql(`
    query buyerSummary($id: UUID) {
        buyer(id: $id) {
            backoffice {
                legalName
            }
        }
    }
`);

export const UPDATE_BUYER = graphql(`
    mutation updateBuyer(
        $id: UUID!,
        $input: UpdateBuyerInput!
    ) {
        buyer {
            backoffice {
                update(id: $id, input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

export const CREATE_BUYER = graphql(`
    mutation createBuyer(
        $input: CreateBuyerInput!
    ) {
        buyer {
            backoffice {
                create(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);

// --- Account namespace (webapp usage) ---

export const GET_BUYER_PROFILE = graphql(`
    query buyerProfile($id: UUID) {
        buyer(id: $id) {
            account {
                contactName
                contactEmail
                publicName
                postalAddress
                billingEmail
                legalName
                vatId
            }
        }
    }
`);

export const GET_BUYER_AUTH_CONTEXT = graphql(`
    query buyerAuthContext($id: UUID) {
        buyer(id: $id) {
            account {
                identifier {
                    id
                }
                contactName
                contactEmail
                broadcastLanguage
                publicName
                broadcastCountries {
                    main
                    countries
                }
            }
        }
    }
`);

export const GET_BUYER_TECHNICAL_SETTINGS = graphql(`
    query buyerTechnicalSettings($id: UUID) {
        buyer(id: $id) {
            account {
                identifier {
                    id
                }
                videoOutputFormat
                videoOutputBitrate
                broadcastLanguage
                broadcastCountries {
                    main
                    countries
                }
            }
        }
    }
`);

export const UPDATE_BUYER_ACCOUNT = graphql(`
    mutation updateBuyerAccount(
        $input: UpdateBuyerAccountInput!
    ) {
        buyer {
            account {
                update(input: $input) {
                    identifier {
                        id
                        sku
                    }
                }
            }
        }
    }
`);
